import React, { useState, createContext } from 'react';
import Navbar from '../Layout/Navbar';
import Footer from '../Layout/Footer';
import { Content } from 'antd/es/layout/layout';

export const LayoutContext = createContext();

const Layout = ({ children, beforeFooter }) => {
  const [activeTab, setActiveTab] = useState(1);
  const [showsidebar, setSidebar] = useState(false);

  return (
    <LayoutContext.Provider value={{ activeTab, setActiveTab, showsidebar, setSidebar }}>
      <div style={{ minHeight: '100vh' }}>
        <Navbar style={{ background: '#001529', color: '#fff' }} />

      <Content style={{ padding: 0, flex: 1, background: 'transparent' }}>
        {children ? children : <div style={{ color: '#888' }}>No content available</div>}
      </Content>

        {beforeFooter}
        <Footer style={{ textAlign: 'center' }} />
      </div>
    </LayoutContext.Provider>
  );
};

export default Layout;